// extracted by mini-css-extract-plugin
export var attachment = "_qc-a";
export var emailContainer = "_qc-4";
export var emailContentPaddedContainer = "_qc-b";
export var emailHeader = "_qc-6";
export var emailIframe = "_qc-3";
export var emailInfoIcon = "_qc-9";
export var emailShortenedSummary = "_qc-e";
export var infoDropdown = "_qc-0";
export var infoRowBoundedContent = "_qc-d";
export var internal = "_qc-5";
export var merchant = "_qc-8";
export var messageInputContainer = "_qc-h";
export var normal = "_qc-7";
export var replyCard = "_qc-f";
export var subtleButton = "_qc-1";
export var subtleButtonIconContainer = "_qc-2";
export var toggleViewRepliesButton = "_qc-c";
export var wrappingText = "_qc-g";